// angular
import {Component, OnInit, inject} from "@angular/core";
import {NgClass} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";
// components
import {MenuButtonComponent} from "../menu-button/menu-button.component";
import {MessagingMenuComponent} from "../messaging-menu/messaging-menu.component";
import {NotificationsMenuComponent} from "../notifications-menu/notifications-menu.component";
import {SettingMenuComponent} from "../setting-menu/setting-menu.component";
import {ProfileMenuComponent} from "../profile-menu/profile-menu.component";
import {MatIconModule} from "@angular/material/icon";
// services
import {ScreenSizeService} from "@app/shared/services/screen-size.service";
import {LayoutService} from "../shared/services/layout.service";
import {BranchService} from "@app/shared/services/branch.service";
// types
import {ScreenSizeType} from "@app/shared/types/screen-size.type";
import {Role} from "@app/shared/types/role.enum";
import {IBranchInfo} from "@app/shared/types/branch.type";
// directives
import {HasAccessDirective} from "@app/core/directives/has-access.directive";

@Component({
  selector: "app-layout-header",
  templateUrl: "./layout-header.component.html",
  styleUrls: ["./layout-header.component.scss"],
  standalone: true,
  imports: [
    NgClass,
    MenuButtonComponent,
    MessagingMenuComponent,
    NotificationsMenuComponent,
    SettingMenuComponent,
    ProfileMenuComponent,
    HasAccessDirective,
    MatIconModule,
    TranslatePipe,
  ],
})
export class LayoutHeaderComponent implements OnInit {
  public Role = Role;
  public userRoles: string[];

  public branchInfo: IBranchInfo;

  public screenSize: ScreenSizeType = "unknown";
  public menuIsOpen?: boolean;

  // dependencies
  private _branchService = inject(BranchService);
  private _screenSizeService = inject(ScreenSizeService);
  private _layoutService = inject(LayoutService);

  constructor() {}

  ngOnInit(): void {
    this._screenSizeService.screenSize$.subscribe(
      (size) => (this.screenSize = size)
    );
    this._layoutService.menuIsOpen$.subscribe((isOpen) => {
      this.menuIsOpen = isOpen;
    });
  }

  public enableEmergencyMode() {
    this._branchService.enableEmergencyMode();
  }
}
